import { render, staticRenderFns } from "./organizationSet.vue?vue&type=template&id=2b4ab5a0&scoped=true"
import script from "./organizationSet.vue?vue&type=script&lang=js"
export * from "./organizationSet.vue?vue&type=script&lang=js"
import style0 from "./organizationSet.vue?vue&type=style&index=0&id=2b4ab5a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ab5a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4ab5a0')) {
      api.createRecord('2b4ab5a0', component.options)
    } else {
      api.reload('2b4ab5a0', component.options)
    }
    module.hot.accept("./organizationSet.vue?vue&type=template&id=2b4ab5a0&scoped=true", function () {
      api.rerender('2b4ab5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/organizationChild/organizationSet.vue"
export default component.exports